import { openDB } from 'idb';
import { capitalizeEachWord } from "cando-util";
import { browser } from "$app/environment";
import { fbConfig } from '$lib/data/generated/fbConfig.js';
import { getCanonicalFormResponses, putCanonicalFormResponses } from './formResponseState.js';

let dbInstance;

const getDb = async (storeName) => {
	if (!browser) return null;

	if (!dbInstance) {
		dbInstance = openDB(fbConfig.projectId, 1, {
			upgrade(db) {
				if (!db.objectStoreNames.contains(storeName)) {
					db.createObjectStore(storeName);
				}
			}
		});
	}

	return dbInstance;
};

export const getResponsesDb = async (col, settingId, formName, collection, appVersion, buildVersion, reset = false) => {
	if (!browser) return {};
	if (!formName) return {};
	if (!collection) return {};
	console.log('getting form data from local db');
	const db = await getDb('formData');
	const existingFormData = reset ? {} : (await db.get('formData', formName)) || {};

	const params = new URLSearchParams(window.location.search);
	const querySource = params.get('source') || '';
	const pathname = window.location.pathname;

	// Persist the stored source if it exists; otherwise, use the URL's source
	const source = querySource || existingFormData.source || '';

	const formData = getCanonicalFormResponses(
		{
			...existingFormData,
			source
		},
		{
			pathname,
			formName,
			collection,
			col,
			settingId,
			appVersion,
			buildVersion
		}
	);

	return putCanonicalFormResponses(db, formName, formData);
};

export const setResponsesDb = async (col, settingId, formName, collection, responses, appVersion, buildVersion) => {
	const formData = getCanonicalFormResponses(responses, {
		formName,
		collection,
		col,
		settingId,
		appVersion,
		buildVersion
	});

	if (!browser || !formName) return formData;
	const db = await getDb('formData');
	await putCanonicalFormResponses(db, formName, formData);
	console.log("Saved to IndexedDB:", formName, collection, col, settingId, formData, appVersion, buildVersion);
	return formData;
};
